import script from "./UserSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserSettings.vue?vue&type=script&setup=true&lang=ts"

import "./UserSettings.vue?vue&type=style&index=0&id=2cfacfd7&lang=css"

const __exports__ = script;

export default __exports__